import React from 'react';

export const Unseen = () => {
    return (
        <svg
            height="24"
            width="24"
            viewBox="0 0 24 24"
            xmlns="http://www.w3.org/2000/svg"
            focusable="false"
            role="img"
            aria-hidden="true"
        >
            <g
                fill="none"
                fill-rule="evenodd"
                stroke="currentColor"
                stroke-width="1.5"
            >
                <path d="M12 18.843c4.05 0 7.717-2.084 11-6.25-3.283-4.864-6.95-7.295-11-7.295S4.283 7.729 1 12.592c3.283 4.167 6.95 6.25 11 6.25Z"></path>
                <path
                    d="m1.5 1.5 21 21"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                ></path>
                <circle cx="12" cy="12" r="4"></circle>
            </g>
        </svg>
    );
};